import { getTrackIdentifiers } from '../services/accountService'

function fetchFollowRequest(accountNumber, type) {
  return getTrackIdentifiers(accountNumber, type)
}

export default fetchFollowRequest



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchFollowRequest.js